module.exports = __webpack_public_path__ + "static/MOD1-952be3bf8f908125f52d7965b4db7ea7.jpg";